import { startCase } from 'lodash'

const CurrentVisit = ({ patientRequestType }) => {
  return (
    <div className="px-6 py-2 mt-4">
      <h3 className="text-xs font-bold text-secondary-900 mb-2">Current Visit</h3>
      <div className="bg-white border border-slate-100 rounded-xl p-4 shadow-sm">
        <h4 className="text-xs font-bold text-secondary-900 leading-snug">Patient Preferences</h4>

        {patientRequestType ? <p className="text-xs text-secondary-700 mt-1">Type: {startCase(patientRequestType)}</p>
          : <p className="text-xs text-secondary-700 mt-1">Patient has not yet completed scheduling preferences. You can still proceed with appointment scheduling based on treatment requirements.</p>
        }
      </div>
    </div>
  );
};

export default CurrentVisit;
